var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-uploader',{staticStyle:{"width":"100%"},attrs:{"color":"primary","hide-upload-btn":"","flat":"","bordered":"","label":_vm.label,"accept":_vm.accept},on:{"added":_vm.addFiles,"removed":_vm.removeFiles}})
}
var staticRenderFns = []

export { render, staticRenderFns }